import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const AddIcon = createIcon({
  displayName: 'AddIcon',
  path: <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
